export default __webpack_public_path__ + "img/homepage.product.03.asset.5c5b4269.jpg";